import React, { useState, useEffect } from 'react';
import { Hyperlink, OverlayTrigger, Tooltip } from '@edx/paragon';
import { getConfig } from '@edx/frontend-platform';
import EditableField from './EditableField';
import icon from '../profile/assets/question-mark-icon.svg';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './ProfilePage.messages';

function UserDataItem({ label, data, changeData, saveData, username, field, onSaveComplete, changeHandler }) {
  const [displayData, setDisplayData] = useState(data);
  const { formatMessage } = useIntl();

  const getDataLabel = data => {
    switch (data) {
      case 'm':
        return formatMessage(messages.selectOptionMale);
      case 'f':
        return formatMessage(messages.selectOptionFemale);
      case 'o':
        return formatMessage(messages.selectOptionOther);
      default:
        return data;
    }
  };

  const accountLink = (
    <Hyperlink destination={getConfig().ACCOUNT_SETTINGS_URL} className="account-link">
      {formatMessage(messages.userAccountLink)}
    </Hyperlink>
  );

  useEffect(() => {
    setDisplayData(data);
  }, [data]);

  return (
    <div className="tw-mb-10">
      <div className={changeData ? '' : 'tw-hidden'}>
        <EditableField
          value={username}
          field={field}
          label={label}
          saveData={saveData}
          onDataChange={newData => setDisplayData(newData)}
          onSaveComplete={onSaveComplete}
          changeHandler={changeHandler}
          initialData={data}
        />
      </div>
      <div className={changeData && field === 'gender' ? 'tw-hidden' : 'tw-block'}>
        <div className="tw-flex tw-gap-1 tw-items-center">
          {field !== 'gender' && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip variant="light" id={`tooltip-${field}`}>
                  Ім'я, що буде вказано у сертифікаті
                </Tooltip>
              }
            >
              <img
                src={icon}
                alt="question icon"
                className="tw-mb-2 -tw-ml-[20px] tw-cursor-pointer"
              />
            </OverlayTrigger>
          )}
          <label className="tw-text-[16px] tw-text-neutral-600 tw-font-medium">{label}</label>
        </div>
        <p className="tw-text-[16px] tw-text-neutral-1000 tw-font-medium tw-leading-[150%]">
          {getDataLabel(displayData) || (
            <span className="tw-text-[14px] tw-text-placeholder tw-font-medium">
              {formatMessage(messages['profile.user.gender.placeholder'])}
            </span>
          )}
        </p>
        {changeData && field !== 'gender' && (
          <div className="tw-bg-gray-300 tw-w-full tw-h-fit tw-px-[20px] tw-py-4 tw-mt-4 tw-rounded-[10px]">
            {formatMessage(messages.nameDescription, {
              accountLink: accountLink,
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default UserDataItem;
